// Persists when the logged-in user last changed a reservation (booked, changed,
// cancelled, accepted or declined an invite), so that a page reload or another
// tab on the same origin still knows /2/user may be lagging behind.
export const RESERVATIONS_CHANGED_STORAGE_KEY = 'resy.reservationsChangedAt';

export const getReservationsChangedAt = (userId) => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(RESERVATIONS_CHANGED_STORAGE_KEY));
    if (!Number.isFinite(stored?.at)) {
      return 0;
    }
    if (userId && stored.userId && String(stored.userId) !== String(userId)) {
      return 0;
    }
    return stored.at;
  } catch (e) {
    return 0;
  }
};

export const setReservationsChangedAt = (userId, at) => {
  try {
    window.localStorage.setItem(RESERVATIONS_CHANGED_STORAGE_KEY, JSON.stringify({ userId, at }));
  } catch (e) {
    // localStorage unavailable (e.g. Safari private mode); fall back to no follow-up refresh
  }
};

export const clearReservationsChangedAt = () => {
  try {
    window.localStorage.removeItem(RESERVATIONS_CHANGED_STORAGE_KEY);
  } catch (e) {
    // localStorage unavailable
  }
};
